var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConsumers({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7264_16742)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9883 2C6.46828 2 1.98828 6.48 1.98828 12C1.98828 17.52 6.46828 22 11.9883 22C17.5083 22 21.9883 17.52 21.9883 12C21.9883 6.48 17.5083 2 11.9883 2ZM15.5983 8.34C16.6683 8.34 17.5283 9.2 17.5283 10.27C17.5283 11.34 16.6683 12.2 15.5983 12.2C14.5283 12.2 13.6683 11.34 13.6683 10.27C13.6583 9.2 14.5283 8.34 15.5983 8.34ZM9.59828 6.76C10.8983 6.76 11.9583 7.82 11.9583 9.12C11.9583 10.42 10.8983 11.48 9.59828 11.48C8.29828 11.48 7.23828 10.42 7.23828 9.12C7.23828 7.81 8.28828 6.76 9.59828 6.76ZM9.59828 15.89V19.64C7.19828 18.89 5.29828 17.04 4.45828 14.68C5.50828 13.56 8.12828 12.99 9.59828 12.99C10.1283 12.99 10.7983 13.07 11.4983 13.21C9.85828 14.08 9.59828 15.23 9.59828 15.89ZM11.9883 20C11.7183 20 11.4583 19.99 11.1983 19.96V15.89C11.1983 14.47 14.1383 13.76 15.5983 13.76C16.6683 13.76 18.5183 14.15 19.4383 14.91C18.2683 17.88 15.3783 20 11.9883 20Z",
    fill: "inherit"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7264_16742"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "inherit"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsumers);
export default __webpack_public_path__ + "static/media/consumers.f1a9bd9ca295d28a5528d5c0e2e30d16.svg";
export { ForwardRef as ReactComponent };